import React from 'react'
import { Container } from "react-bootstrap"
const Map = () => {
    return (
        <>
            <section className='map-wrap'>
                <Container>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12381.75543755967!2d75.8713194724016!3d22.68665395202235!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3d10f773a83db31e!2sInfoGrains%20%7C%20Blockchain%20%7C%20DEFI%20%7C%20DAPPS%20%7C%20DEX%20%7C%20DAO%20%7C%20METAVERSE%20%7C%20NFT%20Development%20%7C%20Smartcontract%20%7C%20IT%20PARK%20%7C%20INDIA!5e0!3m2!1sen!2sin!4v1661146949310!5m2!1sen!2sin" width="100%" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </Container>
            </section>
        </>
    )
}

export default Map